import { render, staticRenderFns } from "./DefaultContent-404.vue?vue&type=template&id=aac98994&"
import script from "./DefaultContent-404.vue?vue&type=script&lang=js&"
export * from "./DefaultContent-404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports